module.exports = __webpack_public_path__ + "static/media/preguntas-banner.57f48206.png";